export function getAnchorName(index?: number) {
  return index ? `_${index}` : undefined;
}
